/**
 * Configuration Firebase — toutes les valeurs viennent des variables d'environnement.
 * Jamais de clé en dur dans ce fichier.
 *
 * Variables requises dans .env (ou Render Environment) :
 *   REACT_APP_FIREBASE_API_KEY
 *   REACT_APP_FIREBASE_AUTH_DOMAIN
 *   REACT_APP_FIREBASE_PROJECT_ID
 *   REACT_APP_FIREBASE_APP_ID
 */

import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

/**
 * Lance le popup Google, récupère l'ID token Firebase,
 * l'envoie au backend GeriaScan pour obtenir un JWT applicatif.
 * Retourne le JWT GeriaScan (string) ou lève une erreur.
 */
export async function signInWithGoogle(backendUrl) {
  const result = await signInWithPopup(auth, googleProvider);
  const idToken = await result.user.getIdToken();

  const res = await fetch(`${backendUrl}/api/auth/firebase-verify`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id_token: idToken }),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.detail ?? `Erreur serveur (${res.status})`);
  }

  const data = await res.json();
  return data.access_token;
}

export async function firebaseSignOut() {
  await signOut(auth);
}

export { auth };
